"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
/**
 * Watches the router state and instantiates the associated UI component.
 * It expects two props: the `routerStore` and a `viewMap`. The `viewMap`
 * is a simple mapping from `routeNames` to React components.
 */
var RouterView = /** @class */ (function (_super) {
    __extends(RouterView, _super);
    function RouterView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RouterView.prototype.render = function () {
        var _a = this.props, routerState = _a.routerStore.routerState, viewMap = _a.viewMap;
        if (process.env.NODE_ENV === 'development') {
            console.log("RouterView.render() - " + JSON.stringify(routerState));
        }
        var view = viewMap[routerState.routeName];
        return view ? view : null;
    };
    RouterView = __decorate([
        mobx_react_1.observer
    ], RouterView);
    return RouterView;
}(React.Component));
exports.RouterView = RouterView;
//# sourceMappingURL=router-view.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobx-state-router/dist/components/router-view.js
// module id = 47
// module chunks = 0